import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDataInput, ILoginNumbers } from '../../../interface/interfaces';

interface IInitialState {
    loginNumbersLoading: boolean;
    loginNumbersData: ILoginNumbers;
    loginNumbersError: string;
}

const initialData = {
    doneProjects: 0,
    projects: 0,
    robots: 0,
    sps: 0,
    anlagen: 0,
    gripper: 0,
    robotMotionInKM: 0,
    sumOfSignals: 0,
    weldPoints: 0,
};

const initialState: IInitialState = {
    loginNumbersLoading: false,
    loginNumbersData: initialData,
    loginNumbersError: '',
};

const loginNumbersSlice = createSlice({
    name: 'loginNumbers',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchLoginNumbersPending: (state: IInitialState, action: PayloadAction<IDataInput>) => {
            state.loginNumbersLoading = true;
            state.loginNumbersData = initialData;
        },

        fetchLoginNumbersFulfilled: (state: IInitialState, action: PayloadAction<ILoginNumbers>) => {
            state.loginNumbersLoading = false;
            state.loginNumbersData = action.payload;
            state.loginNumbersError = '';
        },

        fetchLoginNumbersFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.loginNumbersLoading = false;
            state.loginNumbersData = initialData;
            state.loginNumbersError = action.payload;
        },
    },
});

export default loginNumbersSlice.reducer;
export const { fetchLoginNumbersPending, fetchLoginNumbersFulfilled, fetchLoginNumbersFailure } = loginNumbersSlice.actions;
